import { render, staticRenderFns } from "./CameraPageChangeCameraModeMessage.vue?vue&type=template&id=06610027&scoped=true&"
import script from "./CameraPageChangeCameraModeMessage.vue?vue&type=script&lang=ts&"
export * from "./CameraPageChangeCameraModeMessage.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageChangeCameraModeMessage.vue?vue&type=style&index=0&id=06610027&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06610027",
  null
  
)

export default component.exports